import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TipsState, tipFeatureKey } from './tip.reducer';

const selectTipsFeature = createFeatureSelector<TipsState>(tipFeatureKey);

export const selectCurrentTip = createSelector(
    selectTipsFeature,
    (state) => state.currentTip,
);
